import { post, put } from "../client";
import { GET_APPOINTMENT_REQUESTS, RESPOND_APPOINTMENT_REQUEST, GET_APPOINTMENT_REQUESTS_HISTORY } from "../routes";

const getBusinessId = () => JSON.parse(localStorage.getItem("user_id"));

const APPOINTMENT_REQUESTS = {
  getPending: async (page = 1, size = 20) =>
    await post(GET_APPOINTMENT_REQUESTS, { businessId: getBusinessId(), page, size }),
  respond: async (id, status) => await put(RESPOND_APPOINTMENT_REQUEST(id), { status }),
  getHistory: async (page = 1, size = 50) =>
    await post(GET_APPOINTMENT_REQUESTS_HISTORY, { businessId: getBusinessId(), page, size }),
};
export default APPOINTMENT_REQUESTS;
